import React, { useEffect, useState } from 'react';
import { Download, Folder, TickSquare } from 'react-iconly';
import { getDeliverables, markDeliverableReceived } from '../services/portalService';

const TYPE_LABEL = { link: 'Link', file: 'File', repo: 'Repository', design: 'Design', other: 'Resource' };

const Deliverables = ({ order }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [marking, setMarking] = useState(null);

  useEffect(() => {
    getDeliverables(order.id)
      .then((d) => { setItems(d); })
      .catch(() => { setItems([]); })
      .finally(() => { setLoading(false); });
  }, [order.id]);

  const confirm = async (id) => {
    setMarking(id);
    try {
      const updated = await markDeliverableReceived(id);
      setItems((prev) => prev.map((x) => (x.id === id ? updated : x)));
    } catch (_) { /* ignore */ }
    setMarking(null);
  };

  if (loading) return <div className="portal-spinner" />;

  if (items.length === 0) {
    return (
      <div className="portal-card portal-empty">
        <div className="portal-empty-emoji">🎁</div>
        <h3 style={{ fontFamily: 'var(--v2-font-display)', margin: '8px 0' }}>No deliverables yet</h3>
        <p className="portal-muted">Your final files, links, and assets will appear here as the project is delivered.</p>
      </div>
    );
  }

  return (
    <div>
      <p className="portal-label" style={{ marginBottom: 10 }}>Your deliverables</p>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
        {items.map((d) => (
          <div key={d.id} className="portal-card" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 16 }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
              <Folder set="bulk" size={24} primaryColor="#FF7722" />
              <div>
                <div style={{ fontWeight: 800, fontSize: 15, fontFamily: 'var(--v2-font-display)' }}>{d.title}</div>
                {d.description && <div className="portal-muted" style={{ marginTop: 2 }}>{d.description}</div>}
                <div className="portal-muted" style={{ marginTop: 4, fontSize: 11 }}>
                  {TYPE_LABEL[d.type] || 'Resource'} · delivered {new Date(d.delivered_at).toLocaleDateString('id-ID')}
                </div>
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8, alignItems: 'flex-end' }}>
              {d.url && (
                <a className="portal-btn portal-btn-dark" href={d.url} target="_blank" rel="noreferrer">
                  <Download set="bold" size={16} /> Open
                </a>
              )}
              {d.received_at ? (
                <span className="pill pill-completed">received</span>
              ) : (
                <button className="portal-btn portal-btn-ghost" onClick={() => confirm(d.id)} disabled={marking === d.id}>
                  <TickSquare set="bold" size={16} /> {marking === d.id ? '…' : 'Mark received'}
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Deliverables;
